import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`isPlaying`}</strong><br />{`boolean`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`tells your custom control if the simulation is playing.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`params`}</strong><br />{`object`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`any and all of the simulation parameters.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`pause`}</strong><br />{`function`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`call this function to `}<em parentName="td">{`pause`}</em>{` the simulation (it stops playing, but is not reset.)`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`play`}</strong><br />{`function`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`call this function to start or resume playing the simulation.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`stop`}</strong><br />{`function`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`call this function to stop the simulation (stops playing, time is reset to default, data of simulation is reset.)`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`updateTime`}</strong><br />{`fuction`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`call with a number to update the `}<inlineCode parentName="td">{`tick`}</inlineCode>{` value in the simulation.`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      